<!--serviceGuide.vue  服务指南-->
<template>
  <div class="serviceGuide-all-box">
    <!--巨图-->
    <van-image
      width="100%"
      height="150px"
      fit="fill"
      :src="imageFile"
    />
    <div class="middle-box">
      <!--宫格菜单-->
      <van-grid :column-num="3">
        <van-grid-item v-for="(item, index) in menuList" :key="`frid${index}`" class="grid-box" @click="toPage(item.path)">
          <img slot="icon" :src="item.icon" alt="" class="grid-icon iconfont iconfont-blue" style="width: 50px;height: auto">
          <span slot="text" class="grid-text" :class="item.class">{{ item.title }}</span>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
import imageFile from '@/assets/images/public/yyLogo.png'

export default {
  name: 'ServiceGuide',
  data() {
    return {
      imageFile: imageFile,
      menuList: [
        {
          title: '就诊须知',
          icon: require('../../assets/images/myPeople.png'),
          path: '/jzxz'
        },
        {
          title: '门诊就诊流程',
          icon: require('../../assets/images/guahao.png'),
          path: '/mzjzlc'
        },
        {
          title: '住院流程',
          icon: require('../../assets/images/myQuery.png'),
          path: '/zylc'
        },
        {
          title: '重症精神病门诊特定项目办理流程',
          icon: require('../../assets/images/payMoney.png'),
          class: 'text-15',
          path: '/zzjsbmztdxmbllc'
        },
        {
          title: '精神智力残疾评定流程',
          icon: require('../../assets/images/evaluation.png'),
          path: '/jszlcjpdlc'
        },
        {
          title: '病案复印流程',
          icon: require('../../assets/images/copy.png'),
          path: '/bafylc'
        }
      ]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toPage(url) {
      if (!url) return
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.grid-box {
  text-align: center;
}
.grid-icon {
  font-size: 30px;
  width:50%;
}
.iconfont-blue {
  color: #1677ff;
}
.grid-text {
  margin-top: 10px;
  height: 8vw;
  line-height: 1.2;
}

.text-15 {
  font-size: 14px;
}
</style>
